module.exports = __webpack_public_path__ + "static/media/offer.1e6fb41d.png";